import {
  SingleDatePicker,
  type SingleDatePickerProperties,
} from "@jetblue/kit/date-picker";
import type { FlightSearchFormLabels } from "../../labels";
import { BestFaresToolbar } from "../../toolbar/best-fares-toolbar";
import type { BestFaresCalendarQueryInput } from "../../hooks/use-best-fares-calendar";
import { useBestFaresPickerState } from "./use-best-fares-picker-state";

export type BestFaresSingleDatePickerProperties = Pick<
  SingleDatePickerProperties,
  | "className"
  | "endDate"
  | "error"
  | "isOpen"
  | "onOpenChange"
  | "labels"
  | "selectedDate"
  | "setSelectedDate"
  | "showValidation"
  | "startDate"
  | "headingSlot"
  | "footerSlot"
> &
  BestFaresCalendarQueryInput & {
    bestFareFinderBaseUrl?: string | undefined;
    showDatePickerPricing: boolean;
    toolbarLabels: FlightSearchFormLabels["datePickerToolbar"];
  };
export const BestFaresSingleDatePicker = ({
  bestFareFinderBaseUrl,
  destination,
  isOpen,
  onOpenChange,
  origin,
  passengers,
  showDatePickerPricing,
  toolbarLabels,
  usePoints,
  ...singleDatePickerProperties
}: BestFaresSingleDatePickerProperties) => {
  const { endDate, selectedDate, startDate } = singleDatePickerProperties;

  const {
    announcement,
    message,
    renderDate,
    selectedPrice,
    selectedPriceDescription,
  } = useBestFaresPickerState({
    bestFareFinderBaseUrl,
    destination,
    endDate,
    fareDirection: "outbound",
    origin,
    passengers,
    selectedDepartDate: selectedDate,
    showDatePickerPricing,
    startDate,
    toolbarLabels,
    tripType: "one-way",
    usePoints,
  });
  const footerSlot =
    message || selectedPrice ? (
      <BestFaresToolbar message={message} selectedPrice={selectedPrice} />
    ) : undefined;
  const labels = {
    ...singleDatePickerProperties.labels,
    dateDescriptionAria: announcement,
    doneAria: selectedPriceDescription
      ? `${singleDatePickerProperties.labels.done}. ${selectedPriceDescription}`
      : undefined,
  };

  return (
    <SingleDatePicker
      {...singleDatePickerProperties}
      footerSlot={footerSlot}
      isOpen={isOpen}
      labels={labels}
      onOpenChange={onOpenChange}
      renderDate={renderDate}
    />
  );
};
